import { SignupFlow } from 'corgi-types';

import { useRedirectAfterDelay } from 'common/hooks/signup';
import { useLocalization } from 'common/providers/LocaleProvider';

const ADDRESS_REDIRECT_TRANSLATION_KEYS = new Map([
  [SignupFlow.Checkout, 'h24_single_page_checkout_address_url'],
  [SignupFlow.GiftCardCheckout, 'h24_single_page_digital_checkout_address_url'],
]);

export const useRegistrationRedirect = (userFlow: SignupFlow) => {
  const { p } = useLocalization();

  const addressKey = ADDRESS_REDIRECT_TRANSLATION_KEYS.get(userFlow);
  const redirectParams = addressKey
    ? { redirectUrl: p.t(addressKey), useRouter: true }
    : { userFlow };

  return useRedirectAfterDelay(redirectParams);
};
